export enum StorageKey {
  SelectedPartnerId = 'selected-partner-id',
  Language = 'lng',
}
